import { render, staticRenderFns } from "./lifeGuide.vue?vue&type=template&id=7833a4e3"
import script from "./lifeGuide.vue?vue&type=script&lang=js"
export * from "./lifeGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports